import { FC } from "react";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import 'moment/locale/it';
import "./CalendarPage.css";
import SectionGridHasCalendar from "components/ComponentsToMove/SectionGridHasCalendar";

interface CalendarPageProps { };

const CalendarPage: FC<CalendarPageProps> = () => {
  return (
    <div className="nc-calendar-page w-fullself-center m-auto">
      <SectionGridHasCalendar  />
    </div >
  );
}
export default CalendarPage;
